import { CartItem, Product } from '../types';

class CartService {
  private cartKey = 'herminette_cart';

  getCart(): CartItem[] {
    const cart = localStorage.getItem(this.cartKey);
    return cart ? JSON.parse(cart) : [];
  }

  addToCart(productId: string, quantity: number = 1): void {
    const cart = this.getCart();
    const existingItem = cart.find(item => item.productId === productId);

    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      cart.push({
        productId,
        quantity,
        addedAt: new Date().toISOString()
      });
    }

    localStorage.setItem(this.cartKey, JSON.stringify(cart));
    this.notifyCartChange();
  }

  updateCartItem(productId: string, quantity: number): void {
    const cart = this.getCart();
    const item = cart.find(item => item.productId === productId);

    if (item) {
      if (quantity <= 0) {
        this.removeFromCart(productId);
      } else {
        item.quantity = quantity;
        localStorage.setItem(this.cartKey, JSON.stringify(cart));
        this.notifyCartChange();
      }
    }
  }

  removeFromCart(productId: string): void {
    const cart = this.getCart();
    const filteredCart = cart.filter(item => item.productId !== productId);
    localStorage.setItem(this.cartKey, JSON.stringify(filteredCart));
    this.notifyCartChange();
  }

  clearCart(): void {
    localStorage.removeItem(this.cartKey);
    this.notifyCartChange();
  }

  getCartCount(): number {
    const cart = this.getCart();
    return cart.reduce((total, item) => total + item.quantity, 0);
  }

  isInCart(productId: string): boolean {
    const cart = this.getCart();
    return cart.some(item => item.productId === productId);
  }

  getCartItem(productId: string): CartItem | undefined {
    const cart = this.getCart();
    return cart.find(item => item.productId === productId);
  }

  // Émettre un événement pour notifier les changements
  private notifyCartChange(): void {
    window.dispatchEvent(new CustomEvent('cartUpdated'));
  }
}

export const cartService = new CartService();